import { define, ui, s } from '@owenscorning/pcb.alpha';

import Renderer from '../../../../OC/PageBuilder/FindAContractorMini.jsx';

export default define`Find A Contractor Mini`('1.0.0')({
  thumbnail: ui`Modules/Page/Thumbnails/FindAContractorMini`,
  view: ({ value }) => <Renderer { ...value } />,
  edit: ui`Form`.of({
    heading: ui`Text`({
      label: 'Heading',
      default: 'Find a contractor',
    }),
    bodyCopy: ui`Text`({
      label: 'Body Copy',
      default: 'Get your roof installed by a contractor near {city}, {region}',
    }),
    [s._]: ui`Tip`.of('Interpolation is enabled. Use "{city}" and "{region}"'),
    notFoundCopy: ui`Text`({
      label: 'No contractors found copy',
      default: "We're sorry, we did not find any contractors in your area.",
    }),
    ctaLabel: ui`Text`({
      label: 'CTA Label',
      default: 'View More Contractors',
    }),
    ctaLink: ui`Text`({
      label: 'CTA Link',
      default: 'https://www.owenscorning.com/roofing/contractors',
    }),
  }),
});
